import React from 'react';
import { Clock3, MapPin, UserRound } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { rideStatusMeta } from '../utils/carpoolUi';
import { useAuth } from '../context/AuthContext';

/**
 * Single upcoming ride row (Dashboard / schedule-style layout).
 */
function UpcomingRideRow({ ride }) {
  const { t } = useTranslation();
  const { user } = useAuth();
  const st = rideStatusMeta(ride.status);
  const d = new Date(ride.scheduledDate);
  const hasDriver = Boolean(ride.driver);
  const now = new Date();
  const tomorrow = new Date(now);
  tomorrow.setDate(now.getDate() + 1);

  const dateLabel =
    d.toDateString() === now.toDateString()
      ? t('common.today', 'Днес')
      : d.toDateString() === tomorrow.toDateString()
      ? t('common.tomorrow', 'Утре')
      : d.toLocaleDateString('bg-BG', { weekday: 'short' });

  return (
    <li className="upcoming-ride">
      <div className="upcoming-ride__date">
        <span className="upcoming-ride__day">{d.getDate()}</span>
        <span className="upcoming-ride__mon">{d.toLocaleDateString('bg-BG', { month: 'short' })}</span>
      </div>
      <div className="upcoming-ride__info">
        <div className="upcoming-ride__title-row">
          <div className="upcoming-ride__title">{ride.carpool?.name || '—'}</div>
          <span className="upcoming-ride__when">{dateLabel}</span>
        </div>
        <div className="upcoming-ride__meta">
          <span className="upcoming-ride__meta-item">
            <Clock3 size={13} strokeWidth={2} aria-hidden />
            {ride.scheduledTime || '—'}
          </span>
          {ride.child?.name && (
            <span className="upcoming-ride__meta-item">
              <UserRound size={13} strokeWidth={2} aria-hidden />
              {ride.child.name}
            </span>
          )}
        </div>
        {ride.pickupPoint?.address && (
          <div className="upcoming-ride__submeta">
            <MapPin size={13} strokeWidth={2} aria-hidden />
            <span>{ride.pickupPoint.address}</span>
          </div>
        )}
        {ride.driver && (
          <div className="upcoming-ride__driver">
            {t('schedule.driver', 'Шофьор')}:{' '}
            {ride.driver.id === user?.id
              ? t('common.you', 'Вие')
              : `${ride.driver.firstName} ${ride.driver.lastName}`}
          </div>
        )}
        {!hasDriver && (
          <div className="upcoming-ride__driver upcoming-ride__driver--missing">
            {t('dashboard.needsDriver', 'Нужен шофьор')}
          </div>
        )}
      </div>
      <div className="upcoming-ride__status" style={{ '--st': st.color }}>
        <span className="upcoming-ride__status-icon">{st.icon}</span>
        <small>{st.label}</small>
      </div>
    </li>
  );
}

export default UpcomingRideRow;
